import React from "react";
import styled from "styled-components";
import { ContentBlock } from "../../pages/components";

import colors from "../../../utils/colors";
import { Localize } from "../../../locale/localization";
import { media, mediaMax } from "../../../utils/uiSizes";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 450px) {
    flex-direction: column;
  }
`;

const StyledFigure = styled.figure`
max-width: 600px;
width: 40%;
  margin-right: 2rem;
  @media (max-width: 450px) {
    width:95%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  h6 {
    font-family: FyranSans-SemiBold;
    letter-spacing: 0.125em;
    text-transform: uppercase;
    margin-bottom: 0.625rem;
  }

  h3,
  h4 {
    font-family: FyranSans-SemiBold;
    letter-spacing: 0.013rem;
    margin-bottom: 0.625rem;
  }

  h3 {
    font-size: 22px;
    line-height: 25px;
  }

  h4 {
    font-size: 24px;
    line-height: 24px;
    color: ${colors.BRAND_PINK};
  }

  p {
    font-size:18px;
    line-height:21p;
    margin-bottom: 1rem;
  }

  a {
    margin-top: auto;
  }
`;

const PrizePreview = props => {
  const { image, price, name, type, description, vendorUrl } = props.prize;

  const onItemClick = () => {
    const event = new Event("close-modal");
    document.dispatchEvent(event);
  };

  return (
    <ContentBlock>
      <StyledWrapper>
        {image && (
          <StyledFigure>
            <img src={image} alt="" />
          </StyledFigure>
        )}
        <StyledContentWrapper>
          <h4>
            {price} {Localize("score")}
          </h4>
          <h3>{name}</h3>
          {type && <p>{type}</p>}
          {description && <p>{description}</p>}
          {vendorUrl && (
            <a onClick={onItemClick} href={vendorUrl} target="_blank" rel="noopener noreferrer">
              {/*<Button theme="light_inverse">{Localize('prize.details')}</Button>*/}
              {Localize("prize.link.gogift")}
            </a>
          )}
        </StyledContentWrapper>
      </StyledWrapper>
    </ContentBlock>
  );
};

export default PrizePreview;



// WEBPACK FOOTER //
// ./src/modules/prize/components/PrizePreview.js